import { BookServiceService } from "src/app/services/book-service.service";
import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-users",
  templateUrl: "./users.component.html",
  styleUrls: ["./users.component.scss"]
})
export class UsersComponent implements OnInit {
  Users: any;
  email: string;
  id: string;
  firstName: string;
  lastName: string;
  fullName: any;
  user: any;

  constructor(private ser: BookServiceService) {}

  ngOnInit() {
    this.ser.getUsers().subscribe(data => {
      this.Users = data;
    });
  }
  remove(id) {
    this.ser.removeUser(id).catch(err => console.log(err));
  }

  onOpen(id: string) {
    this.ser.getUser(id).subscribe(data => {
      this.user = data;
      this.id = this.user.id;
      this.email = this.user.email;
      this.firstName = this.user.firstName;
      this.lastName = this.user.lastName;
      this.fullName = this.user.fullName;
    });
  }
  done(id) {
    this.ser
      .editUser(id)
      .update({
        email: this.email,
        firstName: this.firstName,
        lastName: this.lastName,
        fullName: this.fullName
      })
      .catch(err => {
        console.log(err);
      });
  }
}
